export const CONFETTI_WIDTH = 200;
export const CONFETTI_HEIGHT = 308;
export const CONFETTI_TIMEOUT = 100;
export const CONFETTI_EVENT = 'confettiEvent';

export const NUM_PARTICLES = 31;
export const PARTICLE_PATHS = [
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M37.5 0C58.21 0 75 16.79 75 37.5C75 58.21 58.21 75 37.5 75C16.79 75 0 58.21 0 37.5C0 16.79 16.79 0 37.5 0Z',
    'M37.5 0C58.21 0 75 16.79 75 37.5C75 58.21 58.21 75 37.5 75C16.79 75 0 58.21 0 37.5C0 16.79 16.79 0 37.5 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L22.97 22.88L0 18.16L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M37.5 0C58.21 0 75 16.79 75 37.5C75 58.21 58.21 75 37.5 75C16.79 75 0 58.21 0 37.5C0 16.79 16.79 0 37.5 0Z',
    'M37.5 0C58.21 0 75 16.79 75 37.5C75 58.21 58.21 75 37.5 75C16.79 75 0 58.21 0 37.5C0 16.79 16.79 0 37.5 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L22.97 22.88L0 18.16L18.16 0Z',
    'M18.16 0L22.97 22.88L0 18.16L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L22.97 22.88L0 18.16L18.16 0Z',
    'M18.16 0L22.97 22.88L0 18.16L18.16 0Z',
    'M37.5 0C58.21 0 75 16.79 75 37.5C75 58.21 58.21 75 37.5 75C16.79 75 0 58.21 0 37.5C0 16.79 16.79 0 37.5 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L22.97 22.88L0 18.16L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M18.16 0L18.16 18.16L0 18.16L0 0L18.16 0Z',
    'M37.5 0C58.21 0 75 16.79 75 37.5C75 58.21 58.21 75 37.5 75C16.79 75 0 58.21 0 37.5C0 16.79 16.79 0 37.5 0Z',
    'M37.5 0C58.21 0 75 16.79 75 37.5C75 58.21 58.21 75 37.5 75C16.79 75 0 58.21 0 37.5C0 16.79 16.79 0 37.5 0Z',
];

// tslint:disable-next-line:no-http-string
export const SVG_NAMESPACE_URI = 'http://www.w3.org/2000/svg';
